'use client'

import { useEffect } from 'react'

/**
 * Adds a body class on landing and disables browser scroll restoration so that
 * navigating back to this page always starts from the top.
 */
export default function LandingBodyClass() {
  useEffect(() => {
    document.body.classList.add('landingPage')
    return () => document.body.classList.remove('landingPage')
  }, [])

  useEffect(() => {
    if (typeof history !== 'undefined') {
      history.scrollRestoration = 'manual'
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' })

    return () => {
      if (typeof history !== 'undefined') {
        history.scrollRestoration = 'auto'
      }
    }
  }, [])

  return null
}
